import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row } from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { TableContainer } from '@material-ui/core';
import SmallLoader from '../../../shared/components/SmallLoader';
import CustomerTableHead from './CustomerTableHead';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    marginTop: theme.spacing(5),
    width: '100%',
    height: 550,
    overflowX: 'auto',
    overflowY: 'auto',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  tableProductCell: {
    minWidth: 500,
  },
}));

const getSorting = (order, orderBy) => {
  if (order === 'desc') {
    return (a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return -1;
      }
      if (a[orderBy] > b[orderBy]) {
        return 1;
      }
      return 0;
    };
  }
  return (a, b) => {
    if (a[orderBy] > b[orderBy]) {
      return -1;
    }
    if (a[orderBy] < b[orderBy]) {
      return 1;
    }
    return 0;
  };
};

const CustomerTable = ({ data, pageInfo, callback, isTableLoading }) => {  
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState(new Map([]));
  const [page, setPage] = useState(pageInfo?.pageNo);
  const [rowsPerPage, setRowsPerPage] = useState(pageInfo?.pageSize);  

  const handleRequestSort = (event, property) => {
    const orderByTemp = property;
    let orderTemp = 'desc';
    if (orderBy === property && order === 'desc') { orderTemp = 'asc'; }
    setOrder(orderTemp);
    setOrderBy(orderByTemp);
  };

  const handleSelectAllClick = (event, checked) => {
    if (checked) {
      const newSelected = new Map();
      data.map(n => newSelected.set(n.id, true));
      setSelected(newSelected);
      return;
    }
    setSelected(new Map([]));
  };

  const handleClick = (event, id) => {
    const newSelected = new Map(selected);
    const value = newSelected.get(id);
    let isActive = true;
    if (value) {
      isActive = false;
    }
    newSelected.set(id, isActive);
    setSelected(newSelected);
  };

  const handleChangePage = (event, item) => {    
    callback({ cpage: item + 1, cpageSize: rowsPerPage });
    setPage(item);
  };

  const handleChangeRowsPerPage = (event) => {
    callback({ cpage: page + 1, cpageSize: Number(event.target.value) });
    setRowsPerPage(Number(event.target.value));
  };
  
  const isSelected = id => !!selected.get(id);
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, pageInfo.totalElements - (page * rowsPerPage));
  const classes = useStyles();
  return (
    <Col md={12} lg={12}>       
      <Card>
        <CardBody>                 
        <div className={classes.root}>
        <Paper className={classes.paper}>
            <Table stickyHeader className={classes.table} size="small">
              <CustomerTableHead
                numSelected={[...selected].filter(el => el[1]).length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={data.length}
              />
              {isTableLoading ? <TableBody>
                <TableRow>
                  <TableCell colSpan={9} height="150"
                  className="MuiTableCell-alignCenter"
                  align="center">
                  <SmallLoader loading={isTableLoading} />
                  </TableCell>
                  </TableRow>
                  </TableBody>
              : <TableBody>
                {data?.length ? data
                  .sort(getSorting(order, orderBy))
                //  .slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage)
                  .map((d) => {
                    const select = isSelected(d.id);
                    return (
                      <TableRow
                        className="material-table__row"                        
                      >                        
                        <TableCell                         
                          width={5}                        
                        >
                          {d.amazonOrderId}
                        </TableCell>
                        <TableCell                         
                          width="5%"
                        >{d.buyerName}
                        </TableCell>
                        <TableCell                        
                          width="3%"
                        >{d.sku}
                        </TableCell>
                        <TableCell
                        className={classes.tableProductCell}                        
                        >{d.productName}
                        </TableCell>
                        <TableCell
                          className="MuiTableCell-alignRight"                          
                          align="right"
                          width="2%"
                        >{d.quantityShipped}
                        </TableCell>
                        <TableCell
                          className="MuiTableCell-alignRight"                          
                          align="right"
                          width="3%"
                        >$ {d.itemPrice}
                        </TableCell>
                        <TableCell                        
                          width="2%"
                        >{d.currency}
                        </TableCell>
                        <TableCell                         
                          xwidth="15%"
                        >{d.shipAddress1}
                        </TableCell>
                        <TableCell                       
                          xwidth="15%"
                        >{d.shipAddress2}
                        </TableCell>
                        <TableCell                         
                          width="5%"
                        >{d.shipCity}
                        </TableCell>
                        <TableCell                        
                          width="5%"
                        >{d.shipState}
                        </TableCell>
                        <TableCell
                          xwidth="5%"
                        >{d.shipPostalCode}
                        </TableCell>
                        <TableCell
                          width="5%"
                        >{d.shipCountry}
                        </TableCell>
                        <TableCell
                          xwidth="5%"
                        >{d.salesChannel}
                        </TableCell>
                        <TableCell
                          width="5%"
                        >{d.purchaseDate}
                        </TableCell>                        
                      </TableRow>
                    );
                  }) : <TableRow>
                  <TableCell colSpan={12}>No data to display</TableCell>   
                </TableRow>}
                 {/* {emptyRows > 0 && (
                  <TableRow>
                    <TableCell colSpan={15}>No data to display</TableCell>   
                  </TableRow>
                )} */}
              </TableBody>}
            </Table>
            </Paper>
          </div>
          <TablePagination
            component="div"
            className="material-table__pagination"
            count={pageInfo.totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPageOptions={[250, 500, 1000, 1500]}
            dir="ltr"
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

CustomerTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pageInfo: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  isTableLoading: PropTypes.bool.isRequired,
}

export default CustomerTable;
